/*
 * svnty-size-sheet.js - THE SIZE SHEET v2 (2026-09-24). Classic deferred asset, no deps, ASCII, no console.
 *
 * OPEN / CLOSE: one panel per product page (snippets/svnty-size-sheet.liquid), opened by [data-svnty-size-guide], the
 * description's "Find your size" link and window.SVNTY.sizeSheet.open(); closed by the scrim, the X, Escape and history
 * back. THE LOCK: it adds the theme's `overflow-hidden` body class (the one holder) and never touches the root's overflow.
 *
 * THE CHART: the column of the size the picker has selected is highlighted and follows the picker live; tapping a size
 * header shows how that size fits once the finder has run.
 *
 * FIND MY SIZE: height and weight, three segmented controls (an ink thumb slides between the words), one figure that
 * follows the midsection and shoulder choices, then THE ANSWER from window.SvntyFit (assets/svnty-fit-engine.js): the
 * size, the fit band with the body's position between the sizes, one line per measure, the closer and relaxed picks,
 * and "see how any size fits". The shopper's numbers are kept for the visit.
 */
(function () {
  'use strict';
  /* ONE SHEET PER PRODUCT (D5-3, C-03, A RULED): the sheet takes its product as an argument. The page's own sheet (rendered
     by the layout on a product page) answers the page's links; a link inside a quick-add door opens THAT door's product's
     sheet, fetched once (sections/svnty-size-sheet-fetch.liquid, the same snippet) and mounted beside it, on every page.
     Each sheet reads the size picker of its own scope (the page's section, or the door). */
  if (window.__svntySizeSheetInit) return;
  window.__svntySizeSheetInit = true;
  var sheets = {};

  function Sheet(root, scope) {
  var panel = root.querySelector('.svnty-ssheet__panel');
  var chartBox = root.querySelector('[data-ssheet-chart]');
  var form = root.querySelector('[data-ssheet-form]');
  var jsonEl = root.querySelector('[data-ssheet-json]');
  var invalidEl = root.querySelector('[data-ssheet-invalid]');
  var answer = root.querySelector('[data-ssheet-answer]');
  var sizeEl = root.querySelector('[data-ssheet-size]');
  var lineEl = root.querySelector('[data-ssheet-line]');
  var confEl = root.querySelector('[data-ssheet-conf]');
  var band = root.querySelector('[data-ssheet-band]');
  var measuresEl = root.querySelector('[data-ssheet-measures]');
  var chipsEl = root.querySelector('[data-ssheet-chips]');
  var seeingEl = root.querySelector('[data-ssheet-seeing]');
  var figure = root.querySelector('[data-ssheet-figure]');
  var chart = null, isOpen = false, lastFocus = null, last = null;
  try { chart = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { chart = null; }

  function S() { return (window.svntyStrings && window.svntyStrings.size_sheet) || {}; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }   // P35-2 SEC-A-12
  function fill(tpl, map) { return String(tpl || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }

  /* ------------------------------------------------------------ open / close */
  function open(trigger) {
    if (isOpen) return;
    isOpen = true;
    /* P17-29 (round 3, eye pass R2 A P2-3): Safari never focuses a clicked button, so the active element at open is the page;
       the trigger itself takes the focus back when the sheet closes */
    lastFocus = (trigger && trigger.nodeType === 1 && typeof trigger.focus === 'function') ? trigger : document.activeElement;
    root.hidden = false;
    /* the sheet hangs from the header's height: the announcement bar always leaves under a door */
    var hdr = document.querySelector('.svnty-headstack .section-header') || document.querySelector('.header-wrapper');
    /* P20: under a mouse no door parks the bar, so at the top of the page the header ends 34 px lower than its own height and
       the sheet's head, with its close, stood under it. Where the bar is parked the header's height is its edge; where it
       stays the sheet hangs from the header's real bottom edge. The claim lands after this task, so the place is read again
       on the next frame, before the sheet has left the screen's edge. */
    var hang = function () {
      var box = hdr ? hdr.getBoundingClientRect() : null;
      var parked = document.documentElement.classList.contains('svnty-parked');
      panel.style.top = (box ? Math.max(0, Math.round(parked ? box.height : box.bottom)) : 0) + 'px';
    };
    hang();
    if (window.requestAnimationFrame) window.requestAnimationFrame(function () { if (isOpen) hang(); });
    void root.offsetWidth;   /* a forced reflow so the transition runs from the hidden state */
    root.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    highlightCurrent();
    try { history.pushState({ svntySheet: 'size' }, ''); } catch (e) {}
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 60);
    document.addEventListener('keydown', onKey);
  }
  function close(fromPop) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    if (!document.querySelector('quick-add-modal[open]')) document.body.classList.remove('overflow-hidden');   /* a door under it keeps its lock */
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (!isOpen) root.hidden = true; }, 260);
    if (!fromPop) { try { if (history.state && history.state.svntySheet === 'size') history.back(); } catch (e) {} }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  /* C-17: Escape closes this sheet only; a door under it stays open */
  function onKey(e) { if (e.key === 'Escape') { e.stopPropagation(); close(false); } }
  window.addEventListener('popstate', function () { if (isOpen) close(true); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-ssheet-close]'), function (el) {
    el.addEventListener('click', function () { close(false); });
  });

  /* ------------------------------------------------------------ the chart's current column */
  function selectedSize() {
    var sc = scope() || document;
    /* P20: no size is chosen for the shopper until she taps one (the page's and the door's no-size state), so no column is
       marked as hers before that; the finder's answer still marks its own */
    if (sc !== document && (sc.matches('.svnty-door--nosize') || sc.closest('.svnty-door--nosize') || sc.querySelector('.svnty-door--nosize'))) return '';
    var r = sc.querySelector('input[type="radio"][name="Size"]:checked, input[type="radio"][name="size"]:checked');
    if (r) return (r.value || '').trim();
    var sel = sc.querySelector('select[name="Size"], select[name="size"]');
    return sel ? (sel.value || '').trim() : '';
  }
  function headerCells() { return chartBox ? Array.prototype.slice.call(chartBox.querySelectorAll('thead th')) : []; }
  function columnOf(size) {
    var cells = headerCells(), i;
    for (i = 0; i < cells.length; i++) {
      var v = (cells[i].getAttribute('data-size') || cells[i].textContent || '').trim().toUpperCase();
      if (v === String(size).toUpperCase()) return i;
    }
    return -1;
  }
  function highlightCurrent(size) {
    if (!chartBox) return;
    var col = columnOf(size || selectedSize());
    Array.prototype.forEach.call(chartBox.querySelectorAll('tr'), function (tr) {
      Array.prototype.forEach.call(tr.children, function (cell, i) { cell.classList.toggle('is-current', i === col && col > 0); });
    });
  }
  document.addEventListener('change', function (e) {
    var el = e.target, sc = scope();
    if (el && (el.name === 'Size' || el.name === 'size') && (!sc || sc.contains(el))) highlightCurrent(el.value);
  });
  if (chartBox) chartBox.addEventListener('click', function (e) {
    var th = e.target.closest && e.target.closest('thead th');
    if (!th || !last) return;
    var size = (th.getAttribute('data-size') || th.textContent || '').trim();
    if (size && last.sizes.indexOf(size) > -1) see(size);
  });

  /* ------------------------------------------------------------ segmented thumbs + the figure */
  function segIndex(seg) {
    var inputs = seg.querySelectorAll('input[type="radio"]'), i;
    for (i = 0; i < inputs.length; i++) if (inputs[i].checked) return i;
    return 0;
  }
  function syncSeg(seg) {
    seg.style.setProperty('--i', segIndex(seg));
    var shape = seg.getAttribute('data-ssheet-shape'), val = (seg.querySelector('input:checked') || {}).value;
    if (shape && figure && val) figure.setAttribute('data-' + shape, val);
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-ssheet-seg]'), function (seg) {
    syncSeg(seg);
    seg.addEventListener('change', function () { syncSeg(seg); });
  });

  /* ------------------------------------------------------------ the answer */
  function inputs() {
    return {
      h: parseFloat(form.height.value), w: parseFloat(form.weight.value),
      fit: (form.querySelector('input[name="fit"]:checked') || {}).value || 'true',
      belly: (form.querySelector('input[name="belly"]:checked') || {}).value || 'avg',
      shoulders: (form.querySelector('input[name="shoulders"]:checked') || {}).value || 'avg',
      type: root.getAttribute('data-product-type') || '',
      title: root.getAttribute('data-product-title') || ''
    };
  }
  function measureRows(m) {
    var s = S(), order = ['chest', 'waist', 'hip', 'thigh', 'length', 'inseam'], html = '';
    order.forEach(function (k) {
      var v = m && m[k]; if (!v || typeof v.delta !== 'number') return;
      var isLen = (k === 'length' || k === 'inseam');
      var word = isLen ? (v.word === 'long' ? s.words.long : v.word === 'short' ? s.words.short : s.words['true']) : (s.words[v.word] || v.word);
      var d = Math.round(v.delta), qual = '';
      var room = typeof v.room === 'number' ? Math.round(v.room) : d;   /* garment minus body: the room the shopper feels */
      if (!isLen) qual = room >= 0 ? fill(s.room, { cm: room }) : fill(s.tight, { cm: Math.abs(room) });
      else if (Math.abs(d) >= 2) qual = (d > 0 ? '+' : '') + d + ' cm';
      var pct = Math.max(0, Math.min(50, Math.abs(v.delta) * 4));
      html += '<li><span class="svnty-ssheet__mname">' + esc(s.measures[k] || k) + '</span>' +
        '<span class="svnty-ssheet__mword">' + esc(word) + (qual ? '<small>' + esc(qual) + '</small>' : '') + '</span>' +
        '<span class="svnty-ssheet__bar" aria-hidden="true"><i class="' + (v.delta < 0 ? 'is-neg' : '') + '" style="width:' + pct + '%"></i></span></li>';
    });
    measuresEl.innerHTML = html;
  }
  function bandDot(r) {
    /* the body's place between the sizes: linear in the deciding measure's garment values */
    var key = r.limitedBy || (r.family === 'tops' ? 'chest' : 'waist');
    var n = r.sizes.length; if (n < 2 || !r.garment || !r.garment[key] || typeof r.target !== 'object') return 50;
    var g = r.garment[key], R = r.target[key]; if (typeof R !== 'number') return 50;
    var i, x = 0;
    if (R <= g[0]) x = 0;
    else if (R >= g[n - 1]) x = n - 1;
    else for (i = 0; i < n - 1; i++) { if (R >= g[i] && R <= g[i + 1]) { x = i + (R - g[i]) / Math.max(0.1, g[i + 1] - g[i]); break; } }
    return ((x + 0.5) / n) * 100;
  }
  function render(r, above, quiet) {
    var s = S();
    last = r;
    var head = r.size || r.best;
    sizeEl.textContent = head;
    if (above) lineEl.textContent = fill(s.largest, { size: head });
    else lineEl.textContent = r.between ? fill(s.between, { a: r.between.a, b: r.between.b }) : fill(s.fits, { size: head });
    confEl.textContent = above ? '' : (s.conf[r.confidence] || '');
    var html = '';
    r.sizes.forEach(function (z) {
      var cls = 'svnty-ssheet__band-cell' + (z === head ? ' is-pick' : '') + (r.between && (z === r.between.a || z === r.between.b) ? ' is-near' : '');
      html += '<button type="button" class="' + cls + '" data-size="' + esc(z) + '">' + esc(z) + '</button>';
    });
    html += '<span class="svnty-ssheet__band-dot" aria-hidden="true" style="--x:' + bandDot(r).toFixed(1) + '%"></span>';
    band.innerHTML = html;
    measureRows(r.measures && r.measures[head]);
    var chips = '';
    if (r.pick) {
      var closer = r.pick.closer || r.pick.snug, relaxed = r.pick.relaxed || r.pick.loose;
      if (closer && closer !== head) chips += '<button type="button" class="svnty-ssheet__chip" data-size="' + esc(closer) + '">' + esc(fill(s.chipCloser, { size: closer })) + '</button>';
      if (relaxed && relaxed !== head) chips += '<button type="button" class="svnty-ssheet__chip" data-size="' + esc(relaxed) + '">' + esc(fill(s.chipRelaxed, { size: relaxed })) + '</button>';
    }
    chipsEl.innerHTML = chips;
    seeingEl.hidden = true;
    answer.hidden = false;
    highlightCurrent(head);
    if (!quiet) setTimeout(function () { try { answer.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }, 60);
  }
  function see(size) {
    if (!last) return;
    var head = last.size || last.best, m = last.measures && last.measures[size];
    if (!m && window.SvntyFit && chart) { try { var f = window.SvntyFit.fitOf(chart, inputs(), size); m = f && f.measures; } catch (e) { m = null; } }
    if (!m) return;
    measureRows(m);
    Array.prototype.forEach.call(band.querySelectorAll('.svnty-ssheet__band-cell'), function (c) { c.classList.toggle('is-seeing', c.getAttribute('data-size') === size); });
    seeingEl.textContent = size === head ? '' : fill(S().seeing, { size: size });
    seeingEl.hidden = size === head;
    highlightCurrent(size);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.svnty-ssheet__band-cell, .svnty-ssheet__chip');
    if (b) see(b.getAttribute('data-size'));
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = inputs();
      if (!(inp.h >= 140 && inp.h <= 215 && inp.w >= 40 && inp.w <= 180)) { invalidEl.textContent = S().invalid; invalidEl.hidden = false; return; }
      invalidEl.hidden = true;
      if (!window.SvntyFit || !chart) return;
      var r = window.SvntyFit.recommend(chart, inp);
      if (!r) { answer.hidden = true; return; }
      if (!r.ok) {
        if (r.reason === 'above-range' && r.nearest) { r.size = r.best = r.nearest; r.between = null; r.pick = null; r.confidence = 'low'; r.sizes = r.sizes || []; r.measures = r.measures || {}; render(r, true); }
        else answer.hidden = true;
        return;
      }
      render(r);
      try { sessionStorage.setItem('svnty:size-helper', JSON.stringify({ h: inp.h, w: inp.w, fit: inp.fit, belly: inp.belly, sh: inp.shoulders, t: Date.now() })); } catch (err) {}
    });
    /* the shopper's numbers within the visit */
    try {
      var prev = JSON.parse(sessionStorage.getItem('svnty:size-helper') || 'null');
      if (prev && Date.now() - (prev.t || 0) > 7200000) { sessionStorage.removeItem('svnty:size-helper'); prev = null; }   /* P22-21: the house's two hours */
      if (prev) {
        form.height.value = prev.h; form.weight.value = prev.w;
        ['fit', 'belly', 'shoulders'].forEach(function (k) {
          var v = k === 'shoulders' ? prev.sh : prev[k];
          var el = form.querySelector('input[name="' + k + '"][value="' + v + '"]'); if (el) el.checked = true;
        });
        Array.prototype.forEach.call(root.querySelectorAll('[data-ssheet-seg]'), syncSeg);
        /* P22-21 THE ANSWER COMES BACK: the answer she had (stored only on an answer) is drawn again for this piece, quietly */
        var again = function () { var r0 = window.SvntyFit && chart ? window.SvntyFit.recommend(chart, inputs()) : null; if (r0 && r0.ok) render(r0, false, true); };
        if (window.SvntyFit) again(); else setTimeout(again, 400);
      }
    } catch (e) {}
  }
  return { root: root, open: open, close: function () { close(false); }, isOpen: function () { return isOpen; } };
  }

  /* the page's sheet: its scope is the product page's own section, never a door */
  function pageScope() {
    var all = document.querySelectorAll('section[id^="MainProduct-"]');
    for (var i = 0; i < all.length; i++) if (!all[i].closest('quick-add-modal')) return all[i];
    return null;
  }
  var pageRoot = document.querySelector('[data-svnty-ssheet]:not([data-svnty-ssheet-door])');
  var page = pageRoot ? Sheet(pageRoot, pageScope) : null;
  if (page) sheets[pageRoot.getAttribute('data-product-handle') || ''] = page;

  /* a door's sheet: fetched once per product, its inline words and the fit engine run once, its ids made its own */
  var pending = {};
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function doorSheet(handle, door) {
    if (page && pageRoot.getAttribute('data-product-handle') === handle) return Promise.resolve(page);
    if (sheets['door:' + handle]) return Promise.resolve(sheets['door:' + handle]);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch(base() + 'products/' + handle + '?section_id=svnty-size-sheet-fetch', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('sheet'); return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var el = doc.querySelector('[data-svnty-ssheet]'); if (!el) return null;
        Array.prototype.forEach.call(doc.querySelectorAll('script'), function (old) {
          if (el.contains(old)) return;                                   /* the chart's JSON stays data */
          var ty = (old.getAttribute('type') || '').toLowerCase();
          if (ty && ty !== 'text/javascript' && ty !== 'module') return;
          var src = old.getAttribute('src');
          if (src && Array.prototype.some.call(document.scripts, function (x) { return x.getAttribute('src') === src; })) return;
          var n = document.createElement('script');
          if (src) n.src = src; else n.textContent = old.textContent;
          document.head.appendChild(n);
        });
        el.setAttribute('data-svnty-ssheet-door', handle);
        /* P15 (2026-09-28): the figure's states are switched by id (#s-narrow-average...), so those ids stay; the door's sheet had a blank figure since D5-3 */
        Array.prototype.forEach.call(el.querySelectorAll('[id]'), function (x) { if (/^s-/.test(x.id)) return; x.id = x.id + '-door-' + handle; });
        Array.prototype.forEach.call(el.querySelectorAll('[aria-labelledby]'), function (x) { x.setAttribute('aria-labelledby', x.getAttribute('aria-labelledby').split(' ').map(function (k) { return k + '-door-' + handle; }).join(' ')); });
        el = document.importNode(el, true);
        document.body.appendChild(el);
        var sh = Sheet(el, function () { var m = document.querySelector('quick-add-modal[open]'); return m && m.querySelector('[id^="QuickAddInfo-"]'); });
        sheets['door:' + handle] = sh;
        return sh;
      })
      .catch(function () { return null; })
      .then(function (sh) { delete pending[handle]; return sh; });
    return pending[handle];
  }
  function doorHandle(door) {
    var vs = door.querySelector('variant-selects'), u = (vs && vs.getAttribute('data-url')) || '';
    if (!u) { var a = door.querySelector('.product__view-details'); u = (a && a.getAttribute('href')) || ''; }
    return decodeURIComponent((u.match(/\/products\/([^/?#]+)/) || [])[1] || '');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-svnty-size-guide], a[href="#size-guide"], .svnty-size-link') : null;
    if (!t) return;
    var door = t.closest('quick-add-modal');
    if (door) {
      e.preventDefault(); e.stopPropagation();
      var h = doorHandle(door);
      doorSheet(h, door).then(function (sh) {
        if (sh) { sh.open(t); return; }
        /* no sheet could be had: the product page's own guide, never another product's */
        var a = door.querySelector('.product__view-details');
        if (a) window.location.href = (a.getAttribute('href') || '') + '#size-guide';
      });
      return;
    }
    if (!page) return;
    e.preventDefault();
    page.open(t);
  }, true);
  window.SVNTY = window.SVNTY || {};
  window.SVNTY.sizeSheet = page ? { open: page.open, close: page.close } : { open: function () {}, close: function () {} };
  /* P15-5 THE UNIVERSAL SIZE GUIDE (2026-09-28): the size guide page mounts a fetched sheet INLINE (no open, no lock) */
  window.SVNTY.sizeSheet.mount = function (root, scopeFn) { return Sheet(root, scopeFn || function () { return null; }); };
  /* deep link: /products/<handle>#size-guide opens the sheet; the hash is consumed, never kept */
  function openFromHash() { try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {} if (page) page.open(); }
  if (page && location.hash === '#size-guide') setTimeout(openFromHash, 250);
  window.addEventListener('hashchange', function () { if (page && location.hash === '#size-guide') openFromHash(); });
})();
